


// import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import '../instance/InstanceForm.css';
// import ContactDetails from '../contact/ContactDetails';
// import LicenseList from '../license/LicenseList';
// import TenantView from './TenantView';
// import DocumentDetails from '../DocumentDetails';
// import { useAuth } from '../../context/AuthContext';
// import withPermission from '../../utils/withPermission';
// import SelectedContact from './../contact/SelectedContact';
// import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
// import { BiPencil } from "react-icons/bi";
// import { BsChevronLeft } from "react-icons/bs";
// import TenantModal from './TenantModal';
// const TenantDetail = () => {
//     const { id } = useParams(); // Get instance ID from the URL
//     const navigate = useNavigate();
//     const location = useLocation();

//     const [tenantDetails, setTenantDetails] = useState(null);
//     const queryParams = new URLSearchParams(location.search);
//     const initialTab = queryParams.get("activeTab") || "licenseList"; // Default tab
//     const [activeTab, setActiveTab] = useState("tenantInfo");
//     const WithLicensePermission = withPermission(({ children }) => children, ['license-list']);
//     const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
//     const WithDocPermission = withPermission(({ children }) => children, ['document-list']);
//     const [selectedTenant, setSelectedTenant] = useState(null);
//     const [showModal, setShowModal] = useState(false);
//     const [tenants, setTenants] = useState([]);
//     const [industries, setIndustries] = useState([]);

//     const didFetchRef = useRef(false); // Use ref to track whether the API has been called

//     // Function to fetch instance details
//     const fetchTenantDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/tenants/${id}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });

//             setTenantDetails(response.data); // Set the fetched data to state
//         } catch (error) {
//             console.error('Error fetching instance details:', error);
//         }
//     };
//     const fetchIndustries = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let allIndustries = [];



//             const response = await axios.get(`${backendUrl}/api/industries`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             allIndustries = [...allIndustries, ...response.data.industry];


//             setIndustries(allIndustries);
//         } catch (error) {
//             console.error('Error fetching industries:', error);
//         }
//     };
//     const editTenant = async (tenantId, updatedData) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.put(`${backendUrl}/api/tenants/${tenantId}`, updatedData, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const updatedTenant = response.data?.Data;

//             if (updatedTenant) {

//                 updatedTenant.setup_name = updatedTenant.instance.setup_name;
//                 setTenantDetails((prevLead) => ({
//                     ...prevLead,
//                     ...updatedTenant, // Merge updated data
//                 }));
//                 setTenants((prevTenants) =>
//                     prevTenants.map((tenant) =>
//                         tenant.id === updatedTenant.id ? updatedTenant : tenant
//                     )
//                 );
//             } else {
//                 console.error('Update failed, no data returned.');
//             }

//             setShowModal(false);
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response?.data?.errors; // Return validation errors
//             } else {
//                 console.error('Error updating tenant:', error);
//             }
//         }
//     };

//     useEffect(() => {
//         if (!didFetchRef.current) {
//             fetchTenantDetails(); // 
//             didFetchRef.current = true;
//         }
//     }, [id]);
//     useEffect(() => {
//         const queryParams = new URLSearchParams(location.search);
//         const activeTabParam = queryParams.get("activeTab") || "licenseList"; // Default to 'tenantInfo'
//         setActiveTab(activeTabParam); // Set the active tab based on URL parameter
//     }, [location.search]);
//     // Handle back button click
//     const handleBackClick = () => {
//         navigate(-1);
//     };

//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//         navigate(`${location.pathname}?activeTab=${tab}`); // Update URL with active tab
//     };

//     const getAccountStatusBadge = (status) => {
//         switch (status) {
//             case 'active':
//                 return <span className="badge badge-pill badge-soft-success font-size-11 text-success">Active</span>;
//             case 'deactivated':
//                 return <span className="badge badge-pill badge-soft-warning font-size-11 text-warning">Deactivated</span>;
//             case 'suspended':
//                 return <span className="badge badge-pill badge-soft-danger font-size-11 text-danger">Suspended</span>;
//             default:
//                 return <span className="badge badge-pill badge-soft-secondary font-size-12">Unknown</span>;
//         }
//     };
//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Page Title */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-15 d-flex align-items-center">
//                                     <BsChevronLeft
//                                         className='back-button1'
//                                         onClick={() => navigate(-1)}
//                                     />
//                                     <span>Tenant</span>
//                                 </h4>
//                                 <div className="page-title-right br-font">
//                                     <ol className="breadcrumb m-0">
//                                         <li className="breadcrumb-item"><Link to={`/instance/details/${tenantDetails?.instance_id}`}>
//                                             {tenantDetails?.instance?.setup_name || "Instane Details"}
//                                         </Link></li>
//                                         <li className="breadcrumb-item"><Link to={`/tenant/details/${id}?activeTab=tenantInfo`}>
//                                             {tenantDetails?.name || "Tenant Details"}
//                                         </Link></li>
//                                         <li className="breadcrumb-item active"><Link to="/tenants">Details</Link></li>
//                                     </ol>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="p-6 max-w-7xl mx-auto">
//                         <>
//                             <Card className="mb-4 shadow-lg rounded-3 p-2 border-0" style={{ background: "linear-gradient(135deg, #f8f9fa, #ffffff)" }}>
//                                 {/* Header Section with Name and Edit Icon */}
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <Card.Title className="fw-bold font-size-14 text-primary">{tenantDetails?.name}</Card.Title>
//                                     <BiPencil
//                                         className="text-primary hover-effect2 edit-pencil"

//                                         onClick={() => {
//                                             setSelectedTenant(tenantDetails); // Store organisation details
//                                             setShowModal(true); // Open modal
//                                         }} />
//                                 </div>
//                                 <Card.Body className="pt-3">
//                                     <div className="row">
//                                         {/* Left Section */}
//                                         <div className="col-md-6">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block  card-label"><strong>Tenant ID:</strong></span>
//                                                 <span className=" text-muted card-value">{tenantDetails?.tenant_id || '-'}</span>
//                                             </div>
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block  card-label"><strong>Status:</strong></span>
//                                                 <span className=" text-muted card-value">{getAccountStatusBadge(tenantDetails?.account_status) || '-'}</span>
//                                             </div>
//                                         </div>

//                                         {/* Right Section */}
//                                         <div className="col-md-4">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block  card-label"><strong>Address:</strong></span>
//                                                 <span className="fw-semibold text-primary card-value">{tenantDetails?.address || ''}</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </Card.Body>
//                             </Card>
//                             {showModal && (
//                                 <TenantModal
//                                     showModal={showModal}
//                                     handleClose={() => setShowModal(false)}
//                                     tenantData={selectedTenant} // Pass data here
//                                     editTenant={editTenant}
//                                     tenants={tenants}
//                                     industries={industries}
//                                     fetchIndustries={fetchIndustries}
//                                     instanceId={selectedTenant?.instance_id}
//                                     tenantId={id}
//                                 />
//                             )}

//                         </>
//                         <div className="row">
//                             <div className="col-xl-12 col-lg-8">
//                                 <div className="card">
//                                     {/* Nav tabs */}
//                                     <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 font-size-13" role="tablist">
//                                         <li className="nav-item">
//                                             <WithLicensePermission>
//                                             <a
//                                                 className={`nav-link ${activeTab === 'licenseList' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('licenseList')}
//                                                 role="tab"
//                                             >
//                                                 License
//                                             </a>
//                                             </WithLicensePermission>
//                                         </li>
//                                         <li className="nav-item">
//                                             <WithContactPermission>
//                                             <a
//                                                 className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('contactList')}
//                                                 role="tab"
//                                             >
//                                                 Contacts
//                                             </a>
//                                             </WithContactPermission>
//                                         </li>
//                                         <WithDocPermission>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'document' ? 'active' : ''}`}
//                                                 onClick={() => {
//                                                     setActiveTab('document');
//                                                 }}
//                                                 role="tab"
//                                             >
//                                                 Contract
//                                             </a>
//                                         </li>
//                                         </WithDocPermission>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'tenantDetails' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('tenantDetails')}
//                                                 role="tab"
//                                             >
//                                                 Tenant Details
//                                             </a>
//                                         </li>

//                                     </ul>
//                                     <div className="tab-content p-4">
//                                         {/* Contact List Tab */}
//                                         {activeTab === "contactList" && tenantDetails && (
//                                             <div className="tab-pane active" id="contact-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                     <SelectedContact tenantId={tenantDetails?.id}
//                                                         entityType="tenant"
//                                                         fetchTenantData={fetchTenantDetails}
//                                                         tenantData={tenantDetails}
//                                                         setTenantDetails={setTenantDetails}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "licenseList" && tenantDetails && (
//                                             <div className="tab-pane active" id="license-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                     <LicenseList instanceId={id} />

//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "tenantDetails" && tenantDetails && (
//                                             <div className="tab-pane active" id="tenant-details" role="tabpanel">
//                                                 <div className="p-3">
//                                                     <TenantView tenantData={tenantDetails} setTenantDetails={setTenantDetails} />

//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "document" && tenantDetails && (
//                                             <div className="tab-pane active" id="document-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                     <DocumentDetails instanceId={id} />

//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         {/* <div className="row">
//                         <div className="col-12">
//                             <div className="email-leftbar card">
//                                 <div className="card-body">
//                                     <a  onClick={() => handleTabClick('tenantInfo')} className={`list-group-item list-group-item-action ${activeTab === 'tenantInfo' ? 'active-tab' : ''}`}>Tenant Info</a>
//                                     <WithLicensePermission><a  onClick={() => handleTabClick('license')} className={`list-group-item list-group-item-action ${activeTab === 'license' ? 'active-tab' : ''}`}>License</a></WithLicensePermission>
//                                     <WithContactPermission><a  onClick={() => handleTabClick('contacts')} className={`list-group-item list-group-item-action ${activeTab === 'contacts' ? 'active-tab' : ''}`}>Contacts</a></WithContactPermission>
//                                     <WithDocPermission><a  onClick={() => handleTabClick('documents')} className={`list-group-item list-group-item-action ${activeTab === 'documents' ? 'active-tab' : ''}`}>Contracts</a></WithDocPermission>
//                                     <div className="button-container">
//                                         <button onClick={handleBackClick} className="btn btn-secondary mb-4 back">Back</button>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="email-rightbar mb-3">
//                                 <div className="card">
//                                     <div className="card-body">
//                                         {activeTab === 'tenantInfo' && tenantDetails && (
//                                             <TenantView tenantData={tenantDetails}  setTenantDetails={setTenantDetails}/>
//                                         )}
//                                         {activeTab === 'license' && (
//                                             <LicenseList instanceId={id} />
//                                         )}
//                                         {activeTab === 'contacts' && tenantDetails && (
//                                             <SelectedContact tenantId={tenantDetails?.id}
//                                             entityType="tenant"
//                                             fetchTenantData={fetchTenantDetails}
//                                             tenantData={tenantDetails}
//                                             setTenantDetails={setTenantDetails}
//                                             />
//                                         )}
//                                         {activeTab === 'documents' && (
//                                            <DocumentDetails instanceId={id}/>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div> */}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default TenantDetail;


import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Offcanvas, Button } from 'react-bootstrap';
import {
    FaBuilding,
    FaIdCard,
    FaMapMarkerAlt,
    FaKey,
    FaUsers,
    FaFileContract,
    FaInfoCircle,
    FaShieldAlt
} from "react-icons/fa";
import { BiPencil } from "react-icons/bi";
import { BsX } from "react-icons/bs";
import TenantView from './TenantView';
import DocumentDetails from '../DocumentDetails';
import LicenseList from '../license/LicenseList';
import SelectedContact from '../contact/SelectedContact';
import withPermission from '../../utils/withPermission';
import TenantModal from './TenantModal';

const TenantDetail = ({ show, onHide, tenantId }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialTab = queryParams.get("activeTab") || "licenseList";

    const [tenantDetails, setTenantDetails] = useState(null);
    const [activeTab, setActiveTab] = useState(initialTab);
    const [showModal, setShowModal] = useState(false);
    const [selectedTenant, setSelectedTenant] = useState(null);
    const [industries, setIndustries] = useState([]);
    const [closeOffcanvas, setCloseOffcanvas] = useState(false);
    const [showModalAfterClose, setShowModalAfterClose] = useState(false);
    const [modalTenantData, setModalTenantData] = useState(null);

    const WithLicensePermission = withPermission(({ children }) => children, ['license-list']);
    const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
    const WithDocPermission = withPermission(({ children }) => children, ['document-list']);

    const didFetchRef = useRef(false);
    const [localShow, setLocalShow] = useState(show);

    // Sync with parent show prop
    useEffect(() => {
        setLocalShow(show);
    }, [show]);


    // Function to fetch tenant details
    const fetchTenantDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const currentId = tenantId || id;
            const response = await axios.get(`${backendUrl}/api/tenants/${currentId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader:true,
            });

            setTenantDetails(response.data);
        } catch (error) {
            console.error('Error fetching tenant details:', error);
        }
    };

    const fetchIndustries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/industries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader:true,
            });

            setIndustries(response.data.industry || []);
        } catch (error) {
            console.error('Error fetching industries:', error);
        }
    };

    const editTenant = async (tenantId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/tenants/${tenantId}`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const updatedTenant = response.data?.Data;

            if (updatedTenant) {
                updatedTenant.setup_name = updatedTenant.instance?.setup_name;
                setTenantDetails((prevTenant) => ({
                    ...prevTenant,
                    ...updatedTenant,
                }));
            }

            setShowModal(false);
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response?.data?.errors;
            } else {
                console.error('Error updating tenant:', error);
            }
        }
    };

  
      useEffect(() => {
            if (localShow && tenantId) {
                setTenantDetails(null); // Clear previous data
               fetchTenantDetails();
               fetchIndustries();
            }
        }, [localShow, tenantId]);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const handleOffcanvasClose = () => {
        setTenantDetails(null);
        setActiveTab('licenseList');
        didFetchRef.current = false;
        onHide();
    };

    const getAccountStatusBadge = (status) => {
        switch (status) {
            case 'active':
                return <span className="badge bg-success">Active</span>;
            case 'deactivated':
                return <span className="badge bg-warning">Deactivated</span>;
            case 'suspended':
                return <span className="badge bg-danger">Suspended</span>;
            default:
                return <span className="badge bg-secondary">Unknown</span>;
        }
    };

    return (
        <Offcanvas
             show={localShow}
            onHide={handleOffcanvasClose}
            placement="end"
            style={{ width: '1050px' }}
            className="Tenant-offcanvas"
        >
            {/* Offcanvas Header */}
            <Offcanvas.Header className="border-bottom bg-white py-3">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center">
                        <div className="bg-primary rounded-circle p-2 me-3">
                            <FaBuilding className="text-white" size={18} />
                        </div>
                        <div>
                            <h5 className="mb-0 fw-bold text-dark">{tenantDetails?.name}</h5>
                            <small className="text-muted">Tenant ID: {tenantId || id}</small>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <Button
                            variant="outline-primary"
                            size="sm"
                              onClick={() => {
                                setSelectedTenant(tenantDetails);
                                setShowModal(true);
                            }}
                        >
                            <BiPencil className="me-1" />
                            Edit Tenant
                        </Button>

                        <Button
                            variant="light"
                            size="sm"
                            onClick={handleOffcanvasClose}
                            className="border-0"
                        >
                            <BsX size={20} />
                        </Button>
                    </div>
                </div>
            </Offcanvas.Header>

            {/* Offcanvas Body */}
            <Offcanvas.Body className="p-0">
                {/* Tenant Summary Card */}
                <div className="p-4 border-bottom bg-light">
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                    <FaIdCard className="text-primary" size={16} />
                                </div>
                                <div>
                                    <label className="text-muted small mb-1 d-block">Tenant ID</label>
                                    <h6 className="mb-0 fw-semibold text-dark">
                                        {tenantDetails?.tenant_id || 'Not assigned'}
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                    <FaShieldAlt className="text-primary" size={16} />
                                </div>
                                <div>
                                    <label className="text-muted small mb-1 d-block">Status</label>
                                    <h6 className="mb-0 fw-semibold text-dark">
                                        {getAccountStatusBadge(tenantDetails?.account_status)}
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="d-flex align-items-start">
                                <div className="bg-white rounded-circle p-2 shadow-sm me-3 mt-1">
                                    <FaMapMarkerAlt className="text-primary" size={16} />
                                </div>
                                <div className="flex-grow-1">
                                    <label className="text-muted small mb-1 d-block">Address</label>
                                    <div className="bg-white p-3 rounded border">
                                        <p className="mb-0 text-dark">
                                            {tenantDetails?.address || 'No address available for this tenant.'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Navigation Tabs */}
                <div className="border-bottom bg-white">
                    <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                        <WithLicensePermission>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'licenseList' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('licenseList')}
                                    role="tab"
                                >
                                    <FaKey className="me-2" size={14} />
                                    License
                                </button>
                            </li>
                        </WithLicensePermission>

                        <WithContactPermission>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('contactList')}
                                    role="tab"
                                >
                                    <FaUsers className="me-2" size={14} />
                                    Contacts
                                </button>
                            </li>
                        </WithContactPermission>

                        <WithDocPermission>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'document' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('document')}
                                    role="tab"
                                >
                                    <FaFileContract className="me-2" size={14} />
                                    Contract
                                </button>
                            </li>
                        </WithDocPermission>

                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'tenantDetails' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tenantDetails')}
                                role="tab"
                            >
                                <FaInfoCircle className="me-2" size={14} />
                                Tenant Details
                            </button>
                        </li>
                    </ul>
                </div>

                {/* Tab Content */}
                <div className="tab-content p-4 bg-white" style={{ minHeight: '500px', maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
                    {/* License List Tab */}
                    {activeTab === "licenseList" && tenantDetails && (
                        <div className="tab-pane active">
                            <LicenseList tenantId={tenantId || id} />
                        </div>
                    )}

                    {/* Contact List Tab */}
                    {activeTab === "contactList" && tenantDetails && (
                        <div className="tab-pane active">
                            <SelectedContact
                                tenantId={tenantDetails?.id}
                                entityType="tenant"
                                fetchTenantData={fetchTenantDetails}
                                tenantData={tenantDetails}
                                setTenantDetails={setTenantDetails}
                            />
                        </div>
                    )}

                    {/* Document Tab */}
                    {activeTab === "document" && tenantDetails && (
                        <div className="tab-pane active">
                            <DocumentDetails instanceId={tenantId || id} />
                        </div>
                    )}

                    {/* Tenant Details Tab */}
                    {activeTab === "tenantDetails" && (
                        <div className="tab-pane active">
                            {tenantDetails ? (
                                <TenantView
                                    tenantData={tenantDetails}
                                    setTenantDetails={setTenantDetails}
                                />
                            ) : (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-2 text-muted">Loading tenant details...</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </Offcanvas.Body>

            {/* Tenant Modal */}
            {showModal && (
                <TenantModal
                    showModal={showModal}
                    handleClose={() => setShowModal(false)}
                    tenantData={selectedTenant}
                    editTenant={editTenant}
                    industries={industries}
                    fetchIndustries={fetchIndustries}
                    instanceId={selectedTenant?.instance_id}
                    tenantId={tenantId || id}
                />
            )}
        </Offcanvas>
    );
};

export default TenantDetail;